import React, { useState } from 'react';
import dayjs from 'dayjs';
import styled, { keyframes } from 'styled-components';
import { Body3Bold, Body3Light, Body3Regular, CaptionBold, CaptionLight } from '../../../lib/font';
import { Col, Row, truncateString } from '../../../lib/utils';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HoverItem = styled.div<{ isVisible: boolean }>`
    width: 300px;
    min-height: 178px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    position: absolute;
    border-radius: 16px;
    box-shadow: 4px 4px 8px 0px rgba(15, 23, 42, 0.18);
    border: 1px solid #a7f3d0;
    padding: 14px 24px 16px 16px;
    z-index: 99;
    animation: ${(props) => (props.isVisible ? fadeIn : 'none')} 1s ease forwards;
`;

const NewOpportunityBlock = ({
    parentItem,
    parentIndex,
    childItem,
    colPosition,
    rowPosition,
    boxHeight,
    onClickNewOpportunity,
}: any) => {
    const [showModal, setShowModal] = useState(false);
    const displayName =
        childItem?.displayName ||
        childItem?.categoryName ||
        childItem?.name ||
        '수업';
    const title = `신규기회 · ${displayName}`;
    const memberName = childItem?.memberName || childItem?.alias || '회원 미정';
    const hoverStyle = parentIndex > 5 ? { right: '110%' } : { left: '110%' };

    return (
        <Col
            onClick={() => onClickNewOpportunity?.(childItem)}
            style={{
                width: '10.4%',
                height: boxHeight,
                minHeight: 28,
                position: 'absolute',
                marginTop: colPosition,
                marginLeft: `${rowPosition}%`,
                borderRadius: 6,
                justifyContent: 'center',
                alignItems: 'start',
                paddingLeft: '1.11%',
                paddingRight: '1%',
                border: showModal ? '2px solid #D97706' : '2px solid #F59E0B',
                backgroundColor: '#FFFBEB',
                boxShadow: showModal ? '0px 0px 12px 0px rgba(245,158,11,0.28)' : '',
                cursor: 'pointer',
                overflow: 'hidden',
            }}
            onMouseEnter={() => setShowModal(true)}
            onMouseLeave={() => setShowModal(false)}
        >
            {childItem?.duration > 15 ? (
                <Body3Bold style={{ color: '#B45309' }}>{truncateString(title, 9)}</Body3Bold>
            ) : (
                <CaptionBold style={{ color: '#B45309' }}>{truncateString(title, 8)}</CaptionBold>
            )}

            {childItem?.duration > 20 && (
                <Row style={{ alignItems: 'center' }}>
                    <CaptionLight style={{ color: '#92400E' }}>{truncateString(memberName, 8)}</CaptionLight>
                    <CaptionLight style={{ color: '#92400E', marginLeft: 6 }}>{`${childItem?.duration}분`}</CaptionLight>
                </Row>
            )}

            {showModal && (
                <HoverItem style={hoverStyle} isVisible={showModal}>
                    <Row style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                        <Row style={{ width: 200 }}>
                            <Col
                                style={{
                                    width: 8,
                                    height: 22,
                                    borderRadius: 8,
                                    backgroundColor: '#F59E0B',
                                    marginRight: 11,
                                }}
                            />
                            <Body3Bold style={{ color: '#B45309' }}>{`${parentItem?.coachName || ''} 강사`}</Body3Bold>
                        </Row>
                    </Row>

                    <Body3Light style={{ color: '#374151', marginTop: 16 }}>
                        {dayjs(childItem?.startTime).format('M월 D일(ddd)')}
                    </Body3Light>
                    <Body3Bold style={{ color: '#374151', marginTop: 8 }}>
                        {dayjs(childItem?.startTime).format('A hh:mm ~ ')}
                        {dayjs(childItem?.endTime).format('A hh:mm ')}
                        {`(${childItem?.duration}분)`}
                    </Body3Bold>
                    <Body3Regular style={{ width: 252, color: '#374151', marginTop: 8 }}>
                        {memberName} · {title}
                    </Body3Regular>
                    {childItem?.memo && (
                        <Body3Regular style={{ width: 252, color: '#6B7280', marginTop: 8, lineHeight: '20px' }}>
                            {truncateString(childItem.memo, 44)}
                        </Body3Regular>
                    )}
                </HoverItem>
            )}
        </Col>
    );
};

export default NewOpportunityBlock;
